import AppLayout from "Layout/Layout";
import { NonIndexRouteObject } from "react-router";
import { getResourcePath } from "./constant";
import { ListPage } from "pages/sample-module/list-page";
import { DetailPage } from "pages/sample-module/detail-page";
import { EditPage } from "pages/sample-module/edit-page";
import { CreatePage } from "pages/sample-module/create-page";

export const sampleModuleModuleRouters: NonIndexRouteObject[] = [
  {
    path: getResourcePath("sample-module", "list"),
    element: (
      <AppLayout>
        <ListPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("sample-module", "detail"),
    element: (
      <AppLayout>
        <DetailPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("sample-module", "edit"),
    element: (
      <AppLayout>
        <EditPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("sample-module", "create"),
    element: (
      <AppLayout>
        <CreatePage />
      </AppLayout>
    ),
  },
];
